// 12-hour clock helpers. Deskey shows every clock time as 12-hour (e.g. "5:00 PM");
// times are still stored 24-hour ("17:00" / hour 17) so the backend is unchanged.

/** hour 0-23 + minute → "5:00 PM" */
export function formatTime12(hour, minute = 0) {
  const h = Number(hour) || 0;
  const m = Number(minute) || 0;
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
}

/** "HH:MM" (24-hour) → { hour12: 1-12, minute: 0-59, period: 'AM'|'PM' }; empty → null */
export function parse24(value) {
  const match = /^(\d{1,2}):(\d{2})/.exec(value || '');
  if (!match) return null;
  const h = Math.min(23, Number(match[1]));
  const m = Math.min(59, Number(match[2]));
  return { hour12: h % 12 === 0 ? 12 : h % 12, minute: m, period: h < 12 ? 'AM' : 'PM' };
}

/** 12-hour parts → "HH:MM" (24-hour) */
export function to24(hour12, minute, period) {
  const h = (Number(hour12) % 12) + (period === 'PM' ? 12 : 0);
  return `${String(h).padStart(2, '0')}:${String(Number(minute) || 0).padStart(2, '0')}`;
}
